import extensibilityState from '../store/store';
import { ActiveDialog } from '../store/schema/interfaces/Dialog';

export default function getDisplayDialog(): ActiveDialog {
    return extensibilityState.activeDialog;
}
